<template>
  <ion-page>
    
    <ion-content :fullscreen="false">

      <p v-for="x in 100" :key="x">{{ x }}</p>
      
    </ion-content>
    
  </ion-page>
</template>

<script lang="ts">
import { IonContent, IonPage } from '@ionic/vue';

export default {
  name: 'Home',
  components: {
    IonContent,
    IonPage
  }
}
</script>

<style scoped>

</style>